import React, { useCallback, useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const testimonials = [{
  id: 1,
  name: 'Valentina',
  age: 31,
  text: 'Pensé que iba a comer aburrido, pero aprendí recetas que nunca se me hubieran ocurrido.',
  image: 'https://images.unsplash.com/photo-1596436889106-be35e843f974?w=200&h=200&fit=crop&crop=face'
}, {
  id: 2,
  name: 'Camila',
  age: 28,
  text: 'Creía que con SIBO no iba a poder disfrutar la comida… y hoy no siento diferencia.',
  image: 'https://images.unsplash.com/photo-1617529497471-9218633199c0?w=200&h=200&fit=crop&crop=face'
}, {
  id: 3,
  name: 'Florencia',
  age: 35,
  text: 'Los movimientos me ayudaron muchísimo. Sentí la panza mucho más liviana.',
  image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=200&h=200&fit=crop&crop=face'
}, {
  id: 4,
  name: 'Rocío',
  age: 33,
  text: 'A la segunda semana ya notaba cambios reales. Menos hinchazón y más energía.',
  image: 'https://images.unsplash.com/photo-1598550874175-4d0ef436c909?w=200&h=200&fit=crop&crop=face'
}, {
  id: 5,
  name: 'Paula',
  age: 37,
  text: 'Lo mejor fue saber qué comer sin que me duela. Tener todo organizado me cambió completamente.',
  image: 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=200&h=200&fit=crop&crop=face'
}];
export function TestimonialsCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const nextSlide = useCallback(() => {
    setCurrentIndex(prevIndex => prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1);
  }, []);
  const prevSlide = () => {
    setCurrentIndex(prevIndex => prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1);
    setIsAutoPlaying(false);
  };
  const handleNextClick = () => {
    nextSlide();
    setIsAutoPlaying(false);
  };
  useEffect(() => {
    let interval: ReturnType<typeof setInterval>;
    if (isAutoPlaying) {
      interval = setInterval(() => {
        nextSlide();
      }, 5000);
    }
    return () => clearInterval(interval);
  }, [isAutoPlaying, nextSlide]);
  return <section className="py-12 sm:py-16 lg:py-20 bg-white overflow-hidden" data-id="element-182">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-183">
        <div className="text-center mb-12" data-id="element-184">
          <motion.h2 className="text-3xl sm:text-4xl font-playfair font-bold text-brand-text-dark mb-4" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-185">
            Mujeres que ya lo están{' '}
            <span className="italic text-brand-green" data-id="element-186">logrando</span>
          </motion.h2>
          <div className="w-24 h-1 bg-brand-accent-yellow mx-auto rounded-full" data-id="element-187"></div>
        </div>

        <div className="relative max-w-4xl mx-auto" data-id="element-188">
          <div className="absolute top-1/2 -translate-y-1/2 left-0 sm:-left-12 z-10 hidden sm:block" data-id="element-189">
            <button onClick={prevSlide} className="bg-white p-3 rounded-full shadow-lg border border-gray-100 text-brand-green hover:bg-brand-bg-cream transition-colors" aria-label="Anterior testimonio" data-id="element-190">
              <ChevronLeft className="w-6 h-6" data-id="element-191" />
            </button>
          </div>

          <div className="absolute top-1/2 -translate-y-1/2 right-0 sm:-right-12 z-10 hidden sm:block" data-id="element-192">
            <button onClick={handleNextClick} className="bg-white p-3 rounded-full shadow-lg border border-gray-100 text-brand-green hover:bg-brand-bg-cream transition-colors" aria-label="Siguiente testimonio" data-id="element-193">
              <ChevronRight className="w-6 h-6" data-id="element-194" />
            </button>
          </div>

          <div className="overflow-hidden px-4 py-8" data-id="element-195">
            <div className="relative h-[280px] sm:h-[220px]" data-id="element-196">
              <AnimatePresence mode="wait" data-id="element-197">
                <motion.div key={currentIndex} initial={{
                opacity: 0,
                x: 50
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: -50
              }} transition={{
                duration: 0.3
              }} className="absolute inset-0" data-id="element-198">
                  <div className="bg-brand-bg-cream p-8 sm:p-10 rounded-3xl shadow-md border border-brand-bg-beige h-full flex flex-col justify-center relative" data-id="element-199">
                    <Quote className="absolute top-6 right-8 w-12 h-12 text-brand-green/10" data-id="element-200" />

                    <p className="text-lg sm:text-xl text-brand-text-dark font-playfair italic mb-8 relative z-10 leading-relaxed" data-id="element-201">
                      "{testimonials[currentIndex].text}"
                    </p>

                    <div className="flex items-center gap-4 mt-auto" data-id="element-202">
                      <img src={testimonials[currentIndex].image} alt={testimonials[currentIndex].name} className="w-16 h-16 sm:w-14 sm:h-14 rounded-full object-cover border-3 border-brand-green/20 shadow-sm" data-id="element-203" />
                      <div data-id="element-204">
                        <h4 className="font-poppins font-bold text-brand-text-dark" data-id="element-205">
                          {testimonials[currentIndex].name}
                        </h4>
                        <span className="text-sm text-brand-text-medium" data-id="element-206">
                          {testimonials[currentIndex].age} años
                        </span>
                      </div>
                    </div>
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>
          </div>

          <div className="flex justify-center items-center gap-6 mt-6" data-id="element-207">
            <button onClick={prevSlide} className="sm:hidden p-2 text-brand-green" data-id="element-208">
              <ChevronLeft className="w-6 h-6" data-id="element-209" />
            </button>

            <div className="flex gap-2" data-id="element-210">
              {testimonials.map((_, index) => <button key={index} onClick={() => {
              setCurrentIndex(index);
              setIsAutoPlaying(false);
            }} className={`w-2.5 h-2.5 rounded-full transition-all ${index === currentIndex ? 'bg-brand-green w-6' : 'bg-brand-green/30'}`} aria-label={`Ir al testimonio ${index + 1}`} data-id="element-211" />)}
            </div>

            <button onClick={handleNextClick} className="sm:hidden p-2 text-brand-green" data-id="element-212">
              <ChevronRight className="w-6 h-6" data-id="element-213" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}